export default __webpack_public_path__ + "static/media/assignmentsIconHC.87512b9e.svg";